import { ToggleButton } from 'vue-js-toggle-button';
import { Chrome } from 'vue-color';
import { VueEditor } from "vue2-editor";
import CountryService from '../../services/Country.js';
import Helper from '../../Helper.js';
import RadialProgressBar from 'vue-radial-progress';
import moment from 'moment';

if($('#component-university-editor').length){
    var app = new Vue({
        el: '#component-university-editor',
        data: {
            university: {
                countries:[],
                background_colour:'#FF6965',
                collaborators:[]
            },
            loading:true,
            sidebar:true,
            completedSteps: 0,
            totalSteps: 0,
            uploaderErrors:[],
            countries:[],
            radialColour:'#5B45E0',
            radialWidth:5,
            radialInnerColor:'#E0E0E0',
            loadingMessage:'Loading University Editor',
            Helper: Helper,
            moment: moment,
            universityId: universityId,
            openColorPicker:false,
            awsUrl: awsUrl,
            newUserEmail:'',
            showUploadMedia: false,
            dataImages: [],
            targetId: '',
            imageMedia: false,
            bannerMedia: false
        },
        methods: {
            getUniversity(){
                axios.get('/api/v1/university/'+this.universityId)
                .then((response) =>  {
                    this.university = response.data;
                    this.postLoad();
                })
                .catch((error) =>  {
                    this.errorHandler(error);
                })
            },
            saveUniversity(){

                if(this.totalSteps != this.completedSteps){
                    this.$toasted.error("Your university must be 100% complete before you can save it.");
                    return false;
                }

                var form =  document.getElementById('editor-sidebar');
                var formData = new FormData(form);
                formData = this.appendFields(formData);

                this.loading = true;
                this.loadingMessage = 'Saving University';

                if ((!this.university.id && !this.university.image_location_file) || this.imageMedia === true) {
                    formData.append('image_location', this.university.image_location.replace("//" + this.awsUrl + "/", ""));
                    this.imageMedia = false;
                } else if (this.university.image_location_file) {
                    formData.append('image_location', this.university.image_location_file);
                }
                if ((!this.university.id && !this.university.header_banner_image_file) || this.bannerMedia === true) {
                    formData.append('header_banner_image', this.university.header_banner_image.replace("//" + this.awsUrl + "/", ""));
                    this.bannerMedia = false;
                } else if (this.university.header_banner_image_file) {
                    formData.append('header_banner_image', this.university.header_banner_image_file);
                }

                axios.post('/api/v1/university/'+this.universityId, formData)
                .then((response) =>  {

                    this.university = response.data;

                    this.postLoad();

                    this.$toasted.success('Your University has been Saved.');
                })
                .catch((error) =>  {
                    this.errorHandler(error);
                });
            },
            appendFields(formData) {
                formData.append('background_colour', this.university.background_colour);

                let collaboratorIds = this.getCollaboratorIds();
                formData.append('collaboratorIds', collaboratorIds);

                formData.append('_method', 'PATCH');

                return formData;
            },
            updateColour(colours){
                this.university.background_colour = colours.hex;
            },
            previewLogoImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.university.image_location = fileBlob;
                    this.university.image_location_file = file;
                    this.showUploadMedia = false;
                }
            },
            previewBannerImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.university.header_banner_image = fileBlob;
                    this.university.header_banner_image_file = file;
                    this.showUploadMedia = false;
                }
            },
            postLoad() {
                this.$nextTick(function () {
                    this.loading = false;
                    $(".tooltipped").tooltip();
                });
            },
            stepsCalculation(){
                let university = this.university;

                this.totalSteps = 0;
                this.completedSteps = 0;

                university.name ? this.completedSteps++ : null; 
                university.tagline ? this.completedSteps++ : null; 
                university.description ? this.completedSteps++ : null; 
                university.background_colour ? this.completedSteps++ : null; 
                university.country_id ? this.completedSteps++ : null;
                this.totalSteps = 5;
            },
            errorHandler(error){
                if (typeof error.response.data === 'string') {
                    this.$toasted.error(error.response.data);
                } else {
                    let errors = error.response.data.errors;
                    if (errors) {
                        for (let field of Object.keys(errors)) {
                            this.$toasted.error(errors[field][0]);
                        }
                    }
                }
                this.loading = false;
            },
            getCollaboratorIds(){
                return this.university.collaborators.map(user => user.id);
            },
            addCollaborator(){
                if(!this.newUserEmail){
                    this.$toasted.error('Please add an email address');
                    return;
                }

                this.loading = true;
                this.loadingMessage = 'Looking for User';

                axios.post('/api/v1/find-user', {
                    'email':this.newUserEmail,
                })
                    .then((response) =>  {
                        let newUser = response.data;

                        let existingUser = this.university.collaborators.filter(user => {
                            return user.id === newUser.id;
                        });

                        this.newUserEmail = '';

                        if(!existingUser.length){
                            this.university.collaborators.push(newUser);
                            this.$toasted.success('Collaborator added, please save to apply changes');
                        }else{
                            this.$toasted.error('This user is already a collaborator on your university');
                        }

                        this.$nextTick(function () {
                            this.loading = false;
                        });
                    })
                    .catch((error) =>  {
                        this.$toasted.error(error.response.data);
                        this.loading = false;
                    });
            },
            removeUser(index){
                this.university.collaborators.splice(index, 1);
            },
            uploadMedia(id) {
                this.getUploadedMedia();
                this.targetId = id;
                this.showUploadMedia = true;
            },
            getUploadedMedia() {
                axios.get('/api/v1/get-uploaded-media')
                    .then((response) => {
                        if (response.data.hasOwnProperty('uploads')) {
                            this.dataImages = response.data.uploads;
                        }
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            onSelectImage(data) {
                if (this.targetId === 'image') {
                    this.university.image_location = data.src;
                    this.imageMedia = true;
                } else if (this.targetId === 'banner') {
                    this.university.header_banner_image = data.src;
                    this.bannerMedia = true;
                }
                this.showUploadMedia = false;
            },
            selectMethod(result, files) {
                if (result == 'EXTENSION_ERROR') {
                    this.$toasted.error('The selected files contain invalid extensions.');
                    return;
                } else if (result == 'FILE_SIZE_ERROR') {
                    this.$toasted.error('The selected files size exceeded limit.');
                    return;
                }
                if (files && files[0]) {
                    let file = files[0], vm = this, img = new Image();
                    img.onload = function () {
                        if (this.width > 3000 || this.height > 3000) {
                            vm.$toasted.error('The selected image dimensions exceeded limit (3000*3000).');
                        } else {
                            if (vm.targetId === 'image') {
                                vm.previewLogoImage(img.src, file);
                            } else if (vm.targetId === 'banner') {
                                vm.previewBannerImage(img.src, file);
                            }
                        }
                    }
                    img.src = URL.createObjectURL(file);
                }
            }
        },
        mounted () {
            CountryService.getCountries().then(data => {
                this.countries = data;
            });

            this.stepsCalculation();

            if(universityId){
                this.getUniversity(universityId);
                this.cardView = false;
            }else{
                this.postLoad();
            }
        },
        updated: function () {
        },
        components: {
            'vue-editor': VueEditor,
            'chrome-picker': Chrome,
            'ToggleButton': ToggleButton,
            'CountryService': CountryService,
            'RadialProgressBar': RadialProgressBar
        },
        watch: {
            university: {
                handler(val){
                    this.stepsCalculation();
                },
                deep: true
            }
        }
    });
}